/**
 * Shared raster-tint primitive — the alpha-mask "draw then source-in fill" trick
 * used by colour tiling (brief §4). Factored out of TileCanvas.vue's per-frame
 * cache so the export pipeline (tileRenderer.ts) can recolour a layer exactly
 * the same way the live canvas does, without duplicating the drawing logic.
 */
export function tintCanvas(src: HTMLCanvasElement, hex: string): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = src.width;
  c.height = src.height;
  const ctx = c.getContext('2d')!;
  ctx.drawImage(src, 0, 0);
  ctx.globalCompositeOperation = 'source-in';
  ctx.fillStyle = hex;
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.globalCompositeOperation = 'source-over';
  return c;
}
